import React, { Children, useState } from "react";
import filterIcon from "./../../img/icons/filter-icon.svg";
import downArrowIcon from "./../../img/icons/down-arrow.svg";
import localization from "../../data/config";
import "./style.css";

const { filtersApplied } = localization;

const Accordion = ({ title, setMod, mod, children, accordionOpen, setToggle, selectedFiltersCount }) => {

/**
* Handles the key press event, triggering an action if Enter key is pressed.
*
* @param {KeyboardEvent} event - The key press event.
*/
const handleAccordionKeyDown = (event) => {
  if (event.key === 'Enter') {
    setToggle();
  }
};

  return (
    <div className="accordion">
      <div
        className={`accordion-header-container ${accordionOpen ? "open" : ""}`}
        onClick={setToggle} 
        role="button" 
        tabIndex={0} 
        onKeyDown={handleAccordionKeyDown}
        aria-expanded={accordionOpen}
      >
        <div className="accordion-header">
          <img src={filterIcon} alt={title} />
          <div className="feature-title">
            <p className="filter-title">{title}</p>
          </div>
          {!accordionOpen ? 
            <p className="applied-filter">{selectedFiltersCount} {filtersApplied}</p>
            : null}
        </div>
        <span className={accordionOpen ? "open" : "closed"}>
          <img className="arrow" src={downArrowIcon} alt="drop-down icon" />
        </span>
      </div>
      {accordionOpen && (
        <div className="accordion-content-container">
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
